import { FaceManShimmerIcon } from './FaceManShimmerIcon';

/**
 * author: Google
 * id 4680BCD4-CD85-45A0-9F1C-FB367E768664
 * name face-man-shimmer
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-man-shimmer.svg
 * tags
 * - Photography 
 * - Account / User 
 * - Health / Beauty 
 * - People / Family 
 */
export const EmoticonManShimmerIcon = FaceManShimmerIcon;
export default EmoticonManShimmerIcon